const messages = {
  "User does not exist.": "El usuario no existe",
  "Incorrect username or password.": "Usuario o contraseña incorrecto",
  "User is disabled.":
    "Usuario inactivado. Contacta a tu asesor para verificar el estado de tu cuenta",
};

export default messages;
